var sku_values_l = '';
var sku_values_r = '';
var var_l_sph = '';
var var_r_sph = '';
var var_l_cil = '';
var var_r_cil = '';
var var_l_eje = '';
var var_r_eje = '';
var var_l_col = '';
var var_r_col = '';
	
$('#left-poder-sph').click(function() {
    var_l_sph = $('#15137661059442_option_3').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});

$('#left-cilindro').click(function() {
    var_l_cil = $('#15137661059442_option_5').val();
	console.log(var_l_cil); 
	unify_values_l();
	fetch_sku_l();
});

$('#left-eje').click(function() {
    var_l_eje = $('#15137661059442_option_7').val();
	console.log(var_l_eje); 
	unify_values_l();
	fetch_sku_l();
});

$('#right-poder-sph').click(function() {
    var_r_sph = $('#15137661059442_option_4').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});

$('#right-cilindro').click(function() {
    var_r_cil = $('#15137661059442_option_6').val();
	console.log(var_r_cil); 
	unify_values_r();
	fetch_sku_r();
});

$('#right-eje').click(function() {
    var_r_eje = $('#15137661059442_option_8').val();
	console.log(var_r_eje); 
	unify_values_r();
	fetch_sku_r();
});

function unify_values_l(){
	sku_values_l = var_l_sph +'_' +var_l_cil +'_'+var_l_eje;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph +'_' +var_r_cil +'_'+var_r_eje;
	console.log(sku_values_r);
}

function fetch_sku_l(){
 	switch (sku_values_l) { 

	case '-7.00_-2.25_180' : $('#left-sku input').val('SKU Desconocido'); $('.contact-lens-configurator').addClass('left-deny-atc'); $('.left-deny-error').remove(); $('<span class="left-deny-error">Actualmente esta graduación está fuera de disponibilidad por parte de nuestro proveedor. <a href="https://api.whatsapp.com/send?phone=525551172771" target="_blank">Contáctate con uno de nuestros especialistas</a> y te ofreceremos una alternativa</span>').insertBefore('.left-section .box-qty'); break;

 	default: if(var_l_sph != '' && var_l_cil != '' && var_l_eje != '' && var_l_eje != null){$('.contact-lens-configurator').removeClass('left-deny-atc'); $('.left-deny-error').hide();}
  }
}

function fetch_sku_r(){
 	switch (sku_values_r) {

	case '-7.00_-2.25_180' : $('#right-sku input').val('SKU Desconocido'); $('.contact-lens-configurator').addClass('right-deny-atc'); $('.right-deny-error').remove(); $('<span class="right-deny-error">Actualmente esta graduación está fuera de disponibilidad por parte de nuestro proveedor. <a href="https://api.whatsapp.com/send?phone=525551172771" target="_blank">Contáctate con uno de nuestros especialistas</a> y te ofreceremos una alternativa</span>').insertBefore('.right-section .box-qty'); break;

		default: if(var_r_sph != '' && var_r_cil != '' && var_r_eje != '' && var_r_eje != null){$('.contact-lens-configurator').removeClass('right-deny-atc'); $('.right-deny-error').hide();}
  }
}
